/** Site brand assets (Publitio CDN). */
export const SITE_LOGO_URL =
  'https://media.publit.io/file/Argentina-Emprende/ArgentinaEmprende-Logo.png';
